<template>
    <div class="wb-overlay-room-type-anchor"
         :style="{'top': '50%', 'right': '80%'}">
        <div class="wb-overlay-room-type">
            <div class="wb-room-type-input-container">
                <div class="wb-room-type-label">
                    Тип комнаты
                </div>
                <select class="wb-overlay-color-picker-select width: 223px"
                        :value="storeConfiguration.getRoomParamByName('selectedRoomType')"
                        v-on:change="setRoomType($event.target.value)">
                    <option class="wb-overlay-color-picker-select-option"
                            v-for="(value, key) in storeData.getRoomTypes"
                            :key="key"
                            :value="key">
                        {{value}}
                    </option>
                </select>
            </div>
            <div class="wb-room-type-input-container">
                <div class="wb-room-type-label">
                    Высота потолка (мм)
                </div>
                <input type="number" class="wb-overlay-input width: 223px"
                       v-model="getRoomSize"
                       :class="{'wb-danger-input': valueRoomHeight > 7000 || valueRoomHeight < 2000}"
                       @change="setValueHandler($event.target.value)" :title="'2000 ... 7000'" ref="input">
            </div>
            <div class="wb-room-type-input-container">
                <div class="wb-room-type-label">
                    Цвет системы
                </div>
                <select class="wb-overlay-color-picker-select width: 223px"
                        :value="storeConfiguration.getWardrobeBaseColor"
                        v-on:change="setColor($event.target.value)">
                    <option class="wb-overlay-color-picker-select-option"
                            v-for="value in colorOptions"
                            :key="value.id"
                            :value="value.img">
                        {{value.name}}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { useStoreData } from '@/Store/storeData';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { itemColorOptions } from '@/Constants/demoData';

export default {
    name: 'OverlayRoomType',
    setup() {
        const storeData = useStoreData();
        const storeConfiguration = useConfigurationStore();
        return {
            storeData,
            storeConfiguration,
        };
    },
    props: [
        'top',
        'left',
    ],
    data() {
        return {
            valueRoomHeight: null,
            colorOptions: itemColorOptions,
        };
    },
    mounted() {
        this.valueRoomHeight = this.storeConfiguration.getRoomParamByName('height') * 1000;
    },
    computed: {
        getRoomSize() {
            return (this.storeConfiguration.getRoomParamByName('height') * 1000).toFixed();
        },
    },
    methods: {
        setValueHandler(value) {
            this.valueRoomHeight = value;
            if (value > 7000 || value < 2000) {
                return;
            }
            this.storeConfiguration.setRoomParamByName('height', +value / 1000);
        },
        setRoomType(value) {
            this.storeConfiguration.setRoomParamByName('selectedRoomType', value);
            this.storeData.updateRoomDecor();
        },
        setColor(value) {
            this.storeConfiguration.setMainColor(value);
        },
  },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";
@import "CSS/fonts.scss";

.wb-overlay-room-type-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 200;
}

.wb-overlay-room-type {
    padding: 40px;
    background-color: $white;
    display: grid;
    grid-template-rows: max-content max-content;
    grid-row-gap: 24px;
    position: relative;
}

.wb-room-type-input-container {
    display: grid;
    grid-template-rows: max-content max-content;
    grid-row-gap: 8px;
}

.wb-room-type-label {
    @include font-t1;
    color: $darkBlue;
}


.wb-w-223 {
    width: 223px
}

</style>
